<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-full"
    title="確認"
  >
    <template v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <!-- BODY -->
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container fluid>
                <div class="font-weight-bold mb-3">
                  インターネットType4を追加します。 よろしいですか？
                </div>
                <!--  インターネットType4        -->
                <v-row>
                  <v-col>
                    <h3>インターネットType4</h3>
                  </v-col>
                </v-row>
                <v-row class="px-4">
                  <v-col>
                    <app-label-group
                      label="VPN/VNコード"
                      :value="vpnVnCode"
                    ></app-label-group>
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="Type4名"
                      :value="postItem.type4Name"
                    ></app-label-group>
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="メインサイト"
                      :value="$filter.enumTo(postItem.mainSite, 'mainSite')"
                    ></app-label-group>
                  </v-col>
                </v-row>

                <!--  アプライアンス        -->
                <v-row>
                  <v-col>
                    <h3>アプライアンス</h3>
                  </v-col>
                </v-row>
                <v-row class="px-4">
                  <v-col cols="4">
                    <app-label-group label="セキュリティアプライアンス">
                      <template #value>
                        <div class="ml-3">
                          <template v-if="postItem.applianceType === 'IFW'">
                            インターネットFW(100Mbpsベストエフォート)
                          </template>
                          <template v-if="postItem.applianceType === 'UTM'">
                            UTM(1Gbpsベストエフォート)
                          </template>
                        </div>
                      </template>
                    </app-label-group>
                  </v-col>
                  <v-col cols="4">
                    <app-label-group label="インターネット帯域">
                      <template #value>
                        <div class="ml-3">
                          <template v-if="postItem.applianceType === 'IFW'">
                            100Mbpsベストエフォート
                          </template>
                          <template v-if="postItem.applianceType === 'UTM'">
                            1Gbpsベストエフォート
                          </template>
                        </div>
                      </template>
                    </app-label-group>
                  </v-col>
                  <v-col cols="4">
                    <app-label-group label="デフォルトポリシー">
                      <template #value>
                        <div class="ml-3">
                          <template
                            v-if="
                              postItem.policyType === 'ALLOW_SPECIFIC_ONE_WAY'
                            "
                          >
                            編集可能デフォルトポリシー 片方向(特定サービス)
                          </template>
                          <template
                            v-if="postItem.policyType === 'ALLOW_ALL_ONE_WAY'"
                          >
                            編集可能デフォルトポリシー 片方向(any)
                          </template>
                          <template
                            v-if="postItem.policyType === 'ALLOW_ALL_TWO_WAY'"
                          >
                            編集可能デフォルトポリシー 双方向(any)
                          </template>
                        </div>
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--  オプション        -->
                <v-row>
                  <v-col>
                    <h3>オプション</h3>
                  </v-col>
                </v-row>
                <v-row class="px-4">
                  <v-col cols="4">
                    <app-label-group label="追加グローバルIP数" value="0個" />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="M365経路制御オプション"
                      :value="$filter.enumTo(postItem.isMicrosoft365, 'on_off')"
                    ></app-label-group>
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="状態"
                      :value="$filter.enumTo('UNCONNECTED', 'status')"
                    ></app-label-group>
                  </v-col>
                </v-row>
                <!--  保守連絡先情報        -->
                <v-row>
                  <v-col>
                    <h3>保守連絡先情報</h3>
                  </v-col>
                </v-row>
                <v-row class="px-4 pb-4">
                  <v-col cols="4">
                    <app-label-group
                      label="会社名"
                      :value="postItem.maintenance.company"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="部署名"
                      :value="postItem.maintenance.department"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="担当者名"
                      :value="postItem.maintenance.name"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="電話番号"
                      :value="postItem.maintenance.phone"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="メールアドレス"
                      :value="postItem.maintenance.email"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <!-- prettier-ignore  -->
                  <v-col>
                    <!-- eslint-disable-next-line vue/no-mutating-props -->
                    <validation-provider name="note" v-model="postItem.note"
                                         label="オーダー備考"
                                         :rules="{ max: { length: 200 } }"
                                         v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-badge
                          item="オーダー備考"
                          :msg="
                        $filter.message('info_max_length', {
                          maxLength: '200',
                        })
                      "
                          :isRequired="false"
                          placement="end"
                      />
                      <app-form-input
                          v-bind="componentField"
                          :error-messages="errorMessage"
                          :field-meta="meta"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <div class="d-flex justify-center">
                  <v-checkbox
                    hide-details
                    v-model="accepted"
                    label="契約(料金変更)に関わる操作を実施します。"
                  ></v-checkbox>
                </div>
              </v-container>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn
                  type="submit"
                  variant="flat"
                  color="primary"
                  :disabled="!accepted"
                  >はい
                </v-btn>
                <v-btn @click="cancel" variant="outlined" color="primary"
                  >いいえ
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { Type4ServicePostRequest } from "@/apis/ContractChangeType4Api";
import { VueFinalModal } from "vue-final-modal";
import AppLabelGroup from "@/components/AppLabelGroup.vue";

export default defineComponent({
  name: "InternetType4ContractRegisterConfirm",
  components: { AppLabelGroup },
  props: {
    vpnVnCode: {
      type: String as PropType<string>,
      required: true,
    },
    postItem: {
      type: Object as PropType<Type4ServicePostRequest>,
      required: true,
    },
  },
  data() {
    return {
      accepted: false,
    };
  },
  methods: {
    /** 「はい」選択時の挙動 */
    submit() {
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
